import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MobileHomePage from './pages/MobileHomePage';
import MobileLogin from './pages/MobileLogin';
import MobileSignUp from './pages/MobileSignUP';
import MobileFindId from './pages/MobileFindId';
import MobileFindPw from './pages/MobileFindPw';
import ViolationRegister from './pages/insert/section/ViolationRegister';
import DateList from './pages/Diagnostic/DateList';
import ListAll from './pages/Diagnostic/ListAll';
import MyDateList from './pages/mypage/MyDateList';
import MyListAll from './pages/mypage/MyListAll';
import DiagnosticEdit from './pages/Diagnostic/DiagnosticEdit';
import Insert from './pages/insert/Insert';


function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/home" element={<MobileHomePage></MobileHomePage>}></Route>
      <Route path="/" element={<MobileLogin></MobileLogin>}></Route>
      <Route path="/signup" element={<MobileSignUp></MobileSignUp>}></Route>
      <Route path="/findid" element={<MobileFindId></MobileFindId>}></Route>
      <Route path="/findpw" element={<MobileFindPw></MobileFindPw>}></Route>
      <Route path="/insert" element={<Insert></Insert>}></Route>
      <Route path="/datelist" element={<DateList></DateList>}></Route>
      <Route path="/list" element={<ListAll></ListAll>}></Route>
      <Route path="/violationregister" element={<ViolationRegister></ViolationRegister>}></Route>
      <Route path="/mydatelist" element={<MyDateList></MyDateList>}></Route>
      <Route path="/mylistByDate" element={<MyListAll></MyListAll>}></Route>
      <Route path="/diagnostic/edit" element={<DiagnosticEdit></DiagnosticEdit>}></Route>
      
    </Routes>
    </BrowserRouter>
  );
}

export default App;
